import React from "react";
import { useParams } from "react-router-dom";
import { useGetSolutionByUuidQuery } from "../store/slices/settingsSlice";
import SolutionOptionsModal from "./SolutionOptionsModal";
import CreateSolutionModal from "../Library/CreateSolutionModal";
import PurchaseOptions from "../Dashboard/SolutionPurchaseOptions";
import SolutionPurchaseOptions from "../Dashboard/SolutionPurchaseOptions";
import AccessSupportModal from "./AccessSupportModal";

export default function SolutionDetails() {
  const { solutionUuid } = useParams();
  const { data } = useGetSolutionByUuidQuery({ uuid: solutionUuid });
  const solution = data || {};

  return (
    <div>
      <div className="py-2 w-50">
        <div className="fw-bold fs-3">Solution</div>
        <div className="p-3 rounded-3 bg-light mb-2">
          <div>
            <span className="me-2 fw-bold">Solution Name:</span>
            <span>{solution.Label} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Reference:</span>
            <span>{solution.Reference} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Description:</span>
            <span>{solution.Description} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Status:</span>
            <span>{solution.Status} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Version:</span>
            <span>{solution.Version}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Kind:</span>
            <span>{solution.Kind}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Created at:</span>
            <span>{new Date(solution.CreatedAt).toLocaleString()}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Updated at:</span>
            <span>{new Date(solution.UpdatedAt).toLocaleString()}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Email:</span>
            <span>{solution.Email}</span>
          </div>
        </div>
      </div>

      <div className="py-2 w-50">
        <div className="fw-bold fs-3">Components </div>

        {solution.Components?.map((comp, index) => (
          <div key={index} className="p-3 rounded-3 bg-light mb-2">
            <span className="me-2 fw-bold"> {comp.Item.Label}</span>
            <div>{comp.Description}</div>

            <div>
              <span className="me-2 fw-bold">Description:</span>
              <span>{comp.Item.Description}</span>
            </div>
            <div>
              <span>
                <div>
                  {Object.entries(
                    solution.Info?.ActionBreakdownPerComponent?.[
                      comp.ItemUuid
                    ] || {}
                  )
                    .slice()
                    .sort(([workflowKey, workflow]) =>
                      workflow.IsEntrypoint ? -1 : 1
                    )
                    .map(([workflowKey, workflow]) => (
                      <div
                        key={workflowKey}
                        className={`mt-2 p-2 border rounded-2 bg-white position-relative ${
                          workflow.IsEntrypoint ? "border-danger" : ""
                        }`}
                      >
                        {workflow.IsEntrypoint && (
                          <div className="position-absolute top-0 end-0 m-1 badge rounded-pill bg-danger">
                            First workflow{" "}
                          </div>
                        )}
                        <div>
                          <span className="me-2 fw-bold"> Workflow Name: </span>
                          <span>{workflow.WorkflowName}</span>
                        </div>

                        <div>
                          <span className="me-2 fw-bold">
                            Number of actions:{" "}
                          </span>
                          <span>{workflow.Total}</span>
                        </div>
                        <div>
                          <span className="me-2 fw-bold">Can Repeat: </span>
                          <span>{workflow.CanRepeat ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="py-2 w-50">
        <div className="fw-bold fs-3">Client Solutions</div>
        {
          /* Add client solution details here when available */
          solution.ClientSolutions && solution.ClientSolutions.length > 0 ? (
            solution.ClientSolutions.map((clientSolution, index) => (
              <div key={index} className="p-3 rounded-3 bg-light mb-2">
                <div>
                  <span className="me-2 fw-bold">Client Solution Name:</span>
                  <span>{clientSolution.SolutionName}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Client Solution ID:</span>
                  <span>{clientSolution.SolutionUuid}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Client ID:</span>
                  <span>{clientSolution.ClientId}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Email:</span>
                  <span>{clientSolution.Email}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Status:</span>
                  <span>{clientSolution.Status}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Was deployed:</span>
                  <span>
                    {clientSolution.WasDeployed === "true" ? "Yes" : "No"}
                  </span>
                </div>
                {/* Add more fields as necessary */}
              </div>
            ))
          ) : (
            <div>No client solutions available.</div>
          )
        }
      </div>
      {!solution.ClientSolutions?.length && (
        <div className="my-3 w-50">
          <SolutionPurchaseOptions solution={solution} />
        </div>
      )}
      <div className="d-flex gap-2 justify-content-end mt-3 mb-5">
        <SolutionOptionsModal solution={solution} />
        <CreateSolutionModal editedSolution={solution} />
        <AccessSupportModal />
      </div>
    </div>
  );
}
